import { LengthPlayer, PlayersList } from "../lib/players"
import { StoreAction } from "../../../types/store"
import { SET_CURRENT_QUICKSEARCH, SET_LENGTH_PLAYER, SET_PLAYERS_LIST, SetCurrentQuickSearchAction, SetLengthPlayerAction, SetPlayersAction } from "./actions"

export interface StoreState {
  players: PlayersList[]
  lengthPlayer: LengthPlayer | null
  currentQuickSearch: string | null
}

export const initialState: StoreState = {
  players: [],
  lengthPlayer: null,
  currentQuickSearch: null,
}

export default function reducer(state: StoreState, action: StoreAction): StoreState {
  switch (action.type) {
    case SET_LENGTH_PLAYER: {
      const { lengthPlayer } = action as SetLengthPlayerAction
      return {
        ...state,
        lengthPlayer,
      }
    }

    case SET_CURRENT_QUICKSEARCH: {
      const { currentQuickSearch } = action as SetCurrentQuickSearchAction
      return {
        ...state,
        currentQuickSearch,
      }
    }
    case SET_PLAYERS_LIST: {
      const { players } = action as SetPlayersAction
      return {
        ...state,
        players,
      }
    }

    default:
      return state
  }
}
